<template>
  <div class="card-study">
    <card :theme="'orange'" :shadow="true" class="u-align--left u-bg--white">
      <div class="card-container"  v-if="typeof study !== 'undefined'">
        <a :href="'/etude/' + study.node.slug">
          <div class="title">
            <img src="@/assets/img/icons.svg#icon-study" width="45" height="50">
            <big-title :text="'Info étude clinique'" class="u-color--orange"  :hasBlock="true"/>
          </div>
          <div class="separator-study"></div>

            <simple-title :text="study.node.title"/>
            <tag v-if="study.node.type" :tag="study.node.type" class="u-color--orange u-bg--orange-soft"/>
            <pathology :pathology="study.node.pathology.name"/>
            <paragraph :text="study.node.chapo" />
            <block-infos :infos="[{label: 'Porteur de projet', data: study.node.contactName}, {label: 'Contact', data: study.node.contactEmail},{label: 'Date limite d\'inscription', data: study.node.maxSubscriptionDate, date: true}]"/><link-arrow-left :theme="'orange'" :text="'Plus d’informations et coordonnées'" class="u-color--orange"  :href="'/etude/' + study.node.slug" />
        </a>
      </div>

      <div class="card-container" v-else>
        <div class="title">
          <img src="@/assets/img/icons.svg#icon-study" width="45" height="50">
          <big-title :text="'Info étude clinique'" class="u-color--orange"  :hasBlock="true"/>
        </div>
        <div class="separator-study-empty"></div>
      </div>
      <div class="col-12 d-flex justify-content-center button" v-if="flatButton">
        <flat-button :text="'Voir toutes les études'" class="u-bg--orange" :href="'/etudes'"/>
      </div>
    </card>
  </div>
</template>

<script>
import Card from './../Granular/Card'
import BigTitle from '../../Core/BigTitle'
import SimpleTitle from '../../Core/SimpleTitle'
import Paragraph from './../../Core/Paragraph'
import BlockInfos from './../Granular/BlockInfos'
import Tag from "../Granular/Tag";
import Pathology from "../Granular/Pathology";
import FlatButton from './../../Core/FlatButton'
import LinkArrowLeft from "../../Core/Link/LinkArrowLeft";

export default {
  name: 'card-study',
  props: ['study', 'flatButton'],
  components: {
    LinkArrowLeft,
    FlatButton,
    Pathology,
    Tag,
    Card,
    BigTitle,
    SimpleTitle,
    Paragraph,
    BlockInfos,
  }
}
</script>

<style lang="scss">
  .card-study {
    position: relative;

    @include mq($until: MD) {
      margin-top: rem(30px);
    }

    .card-container {
      padding: rem(30px) rem(30px) 0;
      width: 100%;

      @include mq($until: MD) {
        padding: rem(20px) rem(15px) 0;
      }

      .title {
        display: flex;
        align-items: center;
        margin: 0;

        .iconTitle {
          font-size: rem(22px);
          line-height: rem(24px);
          margin-left: rem(15px);
        }
      }

      .simpleTitle {
        padding-bottom: rem(10px);
      }

      .separator {
        display: none;
      }

      .separator-study {
        position: relative;
        margin-bottom: rem(25px);
        padding-top: rem(25px);

        &::after {
          content: '';
          width: 100%;
          position: absolute;
          height: 1px;
          background-color: color(grey-light);
        }
      }

      .separator-study-empty {
        position: relative;
        padding-top: rem(25px);
      }

    }

    .button {
      padding: 0;
      min-height: rem(50px);
      max-height: rem(50px);
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;

      .cta-flat:hover, &:focus {
        background-color: color(orange-hover);
      }
    }
  }
</style>

